export function fillBlank(str) {
  if (!str) {
    return '--'
  } else {
    return str
  }
}



// WEBPACK FOOTER //
// ./src/common/js/fillBlank.js